module.exports = __webpack_public_path__ + "static/media/ls_logo.3ef1d890.png";